import { createSelector } from 'reselect';

export const getSettings = (state) => state.settingsData;

export const getAllSettings = createSelector(
  getSettings,
  (settingsData) => settingsData.settings
);

export const getSysPrompt = createSelector(
  getSettings,
  (settingsData) => settingsData.systemPrompt
);

export const getUserPrompt = createSelector(
  getSettings,
  (settingsData) => settingsData.userPrompt
);

export const getAccessSettings = createSelector(
  getSettings,
  (settingsData) => settingsData.access
);

export const getMaxKeys = createSelector(
  getSettings,
  (settingsData) => settingsData.maxKeys
);
